import { IBulkAction, useAppDispatch } from '../../../../base';
import { jobApplicationActions } from '../../../../actions';
import { useTranslation } from 'react-i18next';

export const useBulkActions = (): Array<IBulkAction> => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const handleBulkReject = (selectedRowIds: Array<string>) => {
        dispatch(
            jobApplicationActions.setBulkRejectApplicationModalData({
                applicationIds: selectedRowIds.map(id => Number(id)),
            })
        );
        dispatch(
            jobApplicationActions.setIsBulkRejectApplicationModalOpen(true)
        );
    };

    return [
        {
            id: 'bulk_reject',
            label: t('jobApplicationsTable.bulkRejectCandidates'),
            onExecute: handleBulkReject,
        },
    ];
};
